<div class="flex items-center justify-between">
  <div class="flex flex-col">
    <div class="flex items-center gap-2">
      <span class="soft-overline">
        {{ bewelf?.artikelnummer }}
      </span>
      <soft-serial-number-view [serialNumber]="$safeNavigationMigration(bewelf?.seriennr)" />
    </div>

    <div class="mt-1 mb-1">
      @if (bewelf?.bezeichnung1?.length) {
        <p class="text-base font-semibold">
          {{ bewelf?.bezeichnung1 }}
        </p>
      }
      @if (bewelf?.bezeichnung2?.length) {
        <p class="text-base text-light">
          {{ bewelf?.bezeichnung2 }}
        </p>
      }
      @if (bewelf?.bezeichnung3?.length) {
        <p class="text-base text-light">
          {{ bewelf?.bezeichnung3 }}
        </p>
      }
    </div>
    @if (!bewelf?.bezeichnung1 && bewelf?.zeilentext?.length) {
      <p
        class="text-base font-semibold mt-1 mb-1"
        >
        {{ bewelf?.zeilentext }}
      </p>
    }
    @if (artehBean) {
      <span class="color-tertiary">
        {{ artehBean?.maxRetourmenge || 0 | number: '1.0-3' }} {{ artehBean.arteh }}
        {{ '#DELIVERY_NOTE.RETOUR.LIST_ITEM_QTY_SUFFIX' | translate }}
      </span>
    }
  </div>

  <div class="flex flex-row justify-end flex-nowrap center-v pl-3 border-box">
    <div class="flex relative">
      @if (hasError && !hasSplit) {
        <small
          class="absolute left-0 bottom-9 text-red-700 text-xs font-medium"
          >
          max. {{ artehBean?.maxRetourmenge ?? 0 | number: '1.2-3' }} {{ artehBean?.arteh }}
        </small>
      }

      @if (hasSplit) {
        <small
          class="absolute left-0 bottom-9 text-warning-700 text-xs font-medium"
          >
          Wird aufgeteilt
        </small>
      }

      <ng-container>
        <soft-number-input
          placeholder="Menge"
          [value]="value?.menge ?? null"
          [class.error]="hasError"
          changeTrigger="blur"
          style="max-width: 80px"
          (valueChange)="onChange(value, menge.value(), $safeNavigationMigration(arteh?.value())!, menge)"
          #menge
          >
        </soft-number-input>

        <div style="width: 100px" class="ml-2">
          <soft-select
            placeholder="EH"
            [value]="artehBean"
            [class.hidden]="(bewelf?.artehBeans?.length || 0) <= 1"
            (valueChange)="onChange(value, menge.value(), $event, menge)"
            #arteh
            >
            @for (arteh of bewelf?.artehBeans ?? []; track arteh.id) {
              <soft-select-option [value]="arteh">
                {{ arteh?.arteh }}
              </soft-select-option>
            }
          </soft-select>
          @if ((bewelf?.artehBeans?.length || 0) <= 1) {
            <span class="soft-title ml-3 color-light" style="width: 100px">{{
              bewelf?.einheit || ''
            }}</span>
          }
        </div>
        @if (artehBean) {
          <small class="absolute left-0 top-9 text-gray-600 text-xs">
            max. {{ $safeNavigationMigration(artehBean?.maxRetourmenge) | number: '1.2-3' }} {{ artehBean?.arteh }}
          </small>
        }
      </ng-container>
      <span class="detail-area mt-1 ml-1" (click)="onShowExtendedUnitDialog(value)">
        <i class="fa-regular fa-calculator"></i>
      </span>
    </div>
  </div>
</div>
